import { IAsset } from '../types/assets.type';
import $http from '../services/AxiosInstance';
import { ISubAsset } from '../types/subAssets.type';

interface Params {
  page?: number;
  search?: string;
  riskType?: string;
  assetId?: number;
  deleted?: boolean;
}

class SubAssetsRepository {
  static async getSubAssetsPublic(): Promise<ISubAsset[]> {
    try {
      const {data} = await $http.get('/sub-assets');
      return data.subAssets;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async getSubAssets(params: Params = {}) {
    try {
      let url = `/sub-assets/pro`;
      if(params.page){
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.riskType) {
        url += `&riskType=${params.riskType}`;
      }
      if (params.assetId) {
        url += `&assetId=${params.assetId}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createSubAsset(data: IAsset): Promise<ISubAsset> {
    try {
      const response = await $http.post('/sub-assets', data);

      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateSubAsset(data: IAsset): Promise<ISubAsset> {
    try {
      const response = await $http.patch(`/sub-assets/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deleteSubAsset(id: number): Promise<number> {
    try {
      const response = await $http.delete(`/sub-assets/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async restoreSubAsset(id: number): Promise<number> {
    try {
      const response = await $http.post(`/sub-assets/restore/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
}

export default SubAssetsRepository;
